import React, { useState } from 'react';
import '../App.css';

const PremiumWelcomeOverlay = ({ onClose }) => {
    const [isVisible, setIsVisible] = useState(true);

    const handleClose = () => {
        setIsVisible(false);
        localStorage.setItem('premiumWelcomeShown', 'true');
        if (onClose) {
            onClose();
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className="welcome-overlay">
            <div className="welcome-overlay-content">
                <button className="welcome-close-button" onClick={handleClose}>×</button>
                <h2>Welcome Beyond the Wormhole!</h2>
                <p>Even bigger tunes await you</p>
            </div>
        </div>
    );
};

export default PremiumWelcomeOverlay;
